import axios from "axios";

const client = axios.create({
  baseURL: `${process.env.REACT_APP_API_URL}/api/donations`, // backend server base
  timeout: 10000,
});

export default client;
